/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminAutofillBreakdownResponse } from '../models';
// @ts-ignore
import type { AdminAutofillOverviewResponse } from '../models';
// @ts-ignore
import type { AdminAutofillSessionsResponse } from '../models';
// @ts-ignore
import type { AdminAutofillTimeseriesResponse } from '../models';
// @ts-ignore
import type { AdminAutofillUsersResponse } from '../models';
// @ts-ignore
import type { AutofillConfigResponse } from '../models';
// @ts-ignore
import type { AutofillEventBody } from '../models';
// @ts-ignore
import type { AutofillEventResponse } from '../models';
// @ts-ignore
import type { AutofillJobBody } from '../models';
// @ts-ignore
import type { AutofillJobMatchResponse } from '../models';
// @ts-ignore
import type { AutofillJobResponse } from '../models';
// @ts-ignore
import type { AutofillProfileResponse } from '../models';
// @ts-ignore
import type { AutofillRatingBody } from '../models';
// @ts-ignore
import type { AutofillRatingResponse } from '../models';
// @ts-ignore
import type { AutofillResumeFileResponse } from '../models';
// @ts-ignore
import type { AutofillStatusResponse } from '../models';
// @ts-ignore
import type { AutofillUninstallBody } from '../models';
// @ts-ignore
import type { AutofillUninstallResponse } from '../models';
// @ts-ignore
import type { AutofillUsageResponse } from '../models';
// @ts-ignore
import type { BuyAiAnswersBody } from '../models';
// @ts-ignore
import type { BuyAiAnswersResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { ExtensionSignedInBody } from '../models';
// @ts-ignore
import type { GenerateAutofillAnswersBody } from '../models';
// @ts-ignore
import type { GenerateAutofillAnswersResponse } from '../models';
// @ts-ignore
import type { ListAutofillSavedAnswersResponse } from '../models';
// @ts-ignore
import type { PreviewAutofillAnswersResponse } from '../models';
// @ts-ignore
import type { PublishedExtensionVersionResponse } from '../models';
// @ts-ignore
import type { RecommendedJobsResponse } from '../models';
// @ts-ignore
import type { SaveAutofillAnswersBody } from '../models';
// @ts-ignore
import type { SaveAutofillAnswersResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpdateAutofillSessionBody } from '../models';
// @ts-ignore
import type { UpdateAutofillSessionResponse } from '../models';
/**
 * AutofillChromeExtensionApiApi - axios parameter creator
 */
export const AutofillChromeExtensionApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Google client id before any user exists. Returns no user data and no secret.
         * @summary Unauthenticated on purpose — the extension\'s sign-in screen needs the
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiAutofillConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/autofill/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Jobs shows on its card — for the extension\'s panel.
         * @summary The candidate\'s match to the job on the employer\'s page — the score Find
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiAutofillJobMatch: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('autofillChromeExtensionApiAutofillJobMatch', 'jobId', jobId)
            const localVarPath = `/autofill/job/{job_id}/match`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiAutofillProfile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/autofill/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Jobs tab — the head of their Find Jobs list. No model call; SQL only.
         * @summary External jobs matched to the candidate\'s profile, for the extension\'s
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiAutofillRecommendedJobs: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/autofill/recommended-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * one they picked, or their default.
         * @summary The caller\'s own resume file, for attaching to an application form: the
         * @param {string | null} [resumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiAutofillResumeFile: async (resumeId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/autofill/resume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (resumeId !== undefined) {
                localVarQueryParameter['resume_id'] = resumeId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiAutofillStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/autofill/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AI credits spent on autofill, and on what — the settings page\'s ledger.
         * @param {number} [days] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiAutofillUsage: async (days?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/autofill/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * extension and the vault\'s Add AI Credits dialog. Raises `not_enough_credits` when the balance can\'t cover the order, the point at which the extension offers Go Pro and the dialog shows its shortfall panel.
         * @summary Spend credits on one or more packs of AI answers — used by both the
         * @param {BuyAiAnswersBody} buyAiAnswersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiBuyAiAnswers: async (buyAiAnswersBody: BuyAiAnswersBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyAiAnswersBody' is not null or undefined
            assertParamExists('autofillChromeExtensionApiBuyAiAnswers', 'buyAiAnswersBody', buyAiAnswersBody)
            const localVarPath = `/autofill/ai-answers/purchase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(buyAiAnswersBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} answerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiDeleteAutofillSavedAnswer: async (answerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'answerId' is not null or undefined
            assertParamExists('autofillChromeExtensionApiDeleteAutofillSavedAnswer', 'answerId', answerId)
            const localVarPath = `/autofill/saved-answers/{answer_id}`
                .replace('{answer_id}', encodeURIComponent(String(answerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GenerateAutofillAnswersBody} generateAutofillAnswersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiGenerateAutofillAnswers: async (generateAutofillAnswersBody: GenerateAutofillAnswersBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateAutofillAnswersBody' is not null or undefined
            assertParamExists('autofillChromeExtensionApiGenerateAutofillAnswers', 'generateAutofillAnswersBody', generateAutofillAnswersBody)
            const localVarPath = `/autofill/answers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateAutofillAnswersBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiGetAdminAutofillBreakdown: async (endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/autofill/statistics/breakdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Chrome extension headline numbers for a window, against the window before it.
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiGetAdminAutofillOverview: async (endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/autofill/statistics/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [ats] 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {AutofillChromeExtensionApiGetAdminAutofillSessionsSortByEnum} [sortBy] 
         * @param {AutofillChromeExtensionApiGetAdminAutofillSessionsSortOrderEnum} [sortOrder] 
         * @param {string | null} [startDate] 
         * @param {AutofillChromeExtensionApiGetAdminAutofillSessionsStatusEnum} [status] 
         * @param {string | null} [userId] 
         * @param {string | null} [version] 
         * @param {boolean} [withNotes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiGetAdminAutofillSessions: async (ats?: string | null, endDate?: string | null, excludeInternal?: boolean, page?: number, pageSize?: number, search?: string | null, sortBy?: AutofillChromeExtensionApiGetAdminAutofillSessionsSortByEnum, sortOrder?: AutofillChromeExtensionApiGetAdminAutofillSessionsSortOrderEnum, startDate?: string | null, status?: AutofillChromeExtensionApiGetAdminAutofillSessionsStatusEnum, userId?: string | null, version?: string | null, withNotes?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/autofill/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ats !== undefined) {
                localVarQueryParameter['ats'] = ats;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (withNotes !== undefined) {
                localVarQueryParameter['with_notes'] = withNotes;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {AutofillChromeExtensionApiGetAdminAutofillTimeseriesGranularityEnum} [granularity] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiGetAdminAutofillTimeseries: async (endDate?: string | null, excludeInternal?: boolean, granularity?: AutofillChromeExtensionApiGetAdminAutofillTimeseriesGranularityEnum, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/autofill/statistics/timeseries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AutofillChromeExtensionApiGetAdminAutofillUsersActivityEnum} [activity] 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {AutofillChromeExtensionApiGetAdminAutofillUsersSortByEnum} [sortBy] 
         * @param {AutofillChromeExtensionApiGetAdminAutofillUsersSortOrderEnum} [sortOrder] 
         * @param {string | null} [startDate] 
         * @param {string | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiGetAdminAutofillUsers: async (activity?: AutofillChromeExtensionApiGetAdminAutofillUsersActivityEnum, endDate?: string | null, excludeInternal?: boolean, page?: number, pageSize?: number, search?: string | null, sortBy?: AutofillChromeExtensionApiGetAdminAutofillUsersSortByEnum, sortOrder?: AutofillChromeExtensionApiGetAdminAutofillUsersSortOrderEnum, startDate?: string | null, userId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/autofill/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (activity !== undefined) {
                localVarQueryParameter['activity'] = activity;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * self-identification declarations.
         * @summary What we remember for this candidate — inspectable because it includes
         * @param {string | null} [atsSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiListAutofillSavedAnswers: async (atsSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/autofill/saved-answers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (atsSource !== undefined) {
                localVarQueryParameter['ats_source'] = atsSource;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * stopped before the model, so the popup can show what a fill would spend before the candidate clicks. Takes the identical body as /autofill/answers so the extension previews exactly what it would send.
         * @summary Costs nothing and fills nothing: the same classification the fill runs,
         * @param {GenerateAutofillAnswersBody} generateAutofillAnswersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiPreviewAutofillAnswers: async (generateAutofillAnswersBody: GenerateAutofillAnswersBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateAutofillAnswersBody' is not null or undefined
            assertParamExists('autofillChromeExtensionApiPreviewAutofillAnswers', 'generateAutofillAnswersBody', generateAutofillAnswersBody)
            const localVarPath = `/autofill/answers/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateAutofillAnswersBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary For the web app: whether the extension a candidate had is out of date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiPublishedExtensionVersionRoute: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/autofill/published-version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * stage reached, a pause. Best-effort; the extension ignores the answer.
         * @summary A funnel step from the extension: panel shown, guided run started, a
         * @param {AutofillEventBody} autofillEventBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiRecordAutofillEvent: async (autofillEventBody: AutofillEventBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'autofillEventBody' is not null or undefined
            assertParamExists('autofillChromeExtensionApiRecordAutofillEvent', 'autofillEventBody', autofillEventBody)
            const localVarPath = `/autofill/event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(autofillEventBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * click on the header\'s Web Store link. Each send updates their one row.
         * @summary The candidate\'s answer to \"how did we do?\" on the success screen, or a
         * @param {AutofillRatingBody} autofillRatingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiRecordAutofillRating: async (autofillRatingBody: AutofillRatingBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'autofillRatingBody' is not null or undefined
            assertParamExists('autofillChromeExtensionApiRecordAutofillRating', 'autofillRatingBody', autofillRatingBody)
            const localVarPath = `/autofill/rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(autofillRatingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * it. Separate from the sign-in routes on purpose: it can fail without touching a login.
         * @summary Sent by the extension after each sign-in to it, so we know who uses
         * @param {ExtensionSignedInBody} extensionSignedInBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiRecordExtensionSignIn: async (extensionSignedInBody: ExtensionSignedInBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'extensionSignedInBody' is not null or undefined
            assertParamExists('autofillChromeExtensionApiRecordExtensionSignIn', 'extensionSignedInBody', extensionSignedInBody)
            const localVarPath = `/autofill/signed-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extensionSignedInBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * marks the install removed, and stores why if the person says. No account (the extension is gone); capped per client address.
         * @summary From the public page Chrome opens when the extension is removed:
         * @param {AutofillUninstallBody} autofillUninstallBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiRecordExtensionUninstall: async (autofillUninstallBody: AutofillUninstallBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'autofillUninstallBody' is not null or undefined
            assertParamExists('autofillChromeExtensionApiRecordExtensionUninstall', 'autofillUninstallBody', autofillUninstallBody)
            const localVarPath = `/autofill/uninstall`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(autofillUninstallBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * extension\'s cover letter: found, or with `create`, added from its ATS.
         * @summary The Abekus job for the employer\'s page the candidate is on, for the
         * @param {AutofillJobBody} autofillJobBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiResolveAutofillJob: async (autofillJobBody: AutofillJobBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'autofillJobBody' is not null or undefined
            assertParamExists('autofillChromeExtensionApiResolveAutofillJob', 'autofillJobBody', autofillJobBody)
            const localVarPath = `/autofill/job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(autofillJobBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remember answers the candidate typed, scoped to the page\'s ATS.
         * @param {SaveAutofillAnswersBody} saveAutofillAnswersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiSaveAutofillAnswers: async (saveAutofillAnswersBody: SaveAutofillAnswersBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveAutofillAnswersBody' is not null or undefined
            assertParamExists('autofillChromeExtensionApiSaveAutofillAnswers', 'saveAutofillAnswersBody', saveAutofillAnswersBody)
            const localVarPath = `/autofill/saved-answers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveAutofillAnswersBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {UpdateAutofillSessionBody} updateAutofillSessionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiUpdateAutofillSession: async (sessionId: string, updateAutofillSessionBody: UpdateAutofillSessionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('autofillChromeExtensionApiUpdateAutofillSession', 'sessionId', sessionId)
            // verify required parameter 'updateAutofillSessionBody' is not null or undefined
            assertParamExists('autofillChromeExtensionApiUpdateAutofillSession', 'updateAutofillSessionBody', updateAutofillSessionBody)
            const localVarPath = `/autofill/session/{session_id}`
                .replace('{session_id}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAutofillSessionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AutofillChromeExtensionApiApi - functional programming interface
 */
export const AutofillChromeExtensionApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AutofillChromeExtensionApiApiAxiosParamCreator(configuration)
    return {
        /**
         * Google client id before any user exists. Returns no user data and no secret.
         * @summary Unauthenticated on purpose — the extension\'s sign-in screen needs the
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiAutofillConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutofillConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiAutofillConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiAutofillConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Jobs shows on its card — for the extension\'s panel.
         * @summary The candidate\'s match to the job on the employer\'s page — the score Find
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiAutofillJobMatch(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutofillJobMatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiAutofillJobMatch(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiAutofillJobMatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiAutofillProfile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutofillProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiAutofillProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiAutofillProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Jobs tab — the head of their Find Jobs list. No model call; SQL only.
         * @summary External jobs matched to the candidate\'s profile, for the extension\'s
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiAutofillRecommendedJobs(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecommendedJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiAutofillRecommendedJobs(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiAutofillRecommendedJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * one they picked, or their default.
         * @summary The caller\'s own resume file, for attaching to an application form: the
         * @param {string | null} [resumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiAutofillResumeFile(resumeId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutofillResumeFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiAutofillResumeFile(resumeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiAutofillResumeFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiAutofillStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutofillStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiAutofillStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiAutofillStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary AI credits spent on autofill, and on what — the settings page\'s ledger.
         * @param {number} [days] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiAutofillUsage(days?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutofillUsageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiAutofillUsage(days, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiAutofillUsage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * extension and the vault\'s Add AI Credits dialog. Raises `not_enough_credits` when the balance can\'t cover the order, the point at which the extension offers Go Pro and the dialog shows its shortfall panel.
         * @summary Spend credits on one or more packs of AI answers — used by both the
         * @param {BuyAiAnswersBody} buyAiAnswersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiBuyAiAnswers(buyAiAnswersBody: BuyAiAnswersBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuyAiAnswersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiBuyAiAnswers(buyAiAnswersBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiBuyAiAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} answerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiDeleteAutofillSavedAnswer(answerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiDeleteAutofillSavedAnswer(answerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiDeleteAutofillSavedAnswer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GenerateAutofillAnswersBody} generateAutofillAnswersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiGenerateAutofillAnswers(generateAutofillAnswersBody: GenerateAutofillAnswersBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateAutofillAnswersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiGenerateAutofillAnswers(generateAutofillAnswersBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiGenerateAutofillAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiGetAdminAutofillBreakdown(endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAutofillBreakdownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiGetAdminAutofillBreakdown(endDate, excludeInternal, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiGetAdminAutofillBreakdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Chrome extension headline numbers for a window, against the window before it.
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiGetAdminAutofillOverview(endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAutofillOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiGetAdminAutofillOverview(endDate, excludeInternal, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiGetAdminAutofillOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [ats] 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {AutofillChromeExtensionApiGetAdminAutofillSessionsSortByEnum} [sortBy] 
         * @param {AutofillChromeExtensionApiGetAdminAutofillSessionsSortOrderEnum} [sortOrder] 
         * @param {string | null} [startDate] 
         * @param {AutofillChromeExtensionApiGetAdminAutofillSessionsStatusEnum} [status] 
         * @param {string | null} [userId] 
         * @param {string | null} [version] 
         * @param {boolean} [withNotes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiGetAdminAutofillSessions(ats?: string | null, endDate?: string | null, excludeInternal?: boolean, page?: number, pageSize?: number, search?: string | null, sortBy?: AutofillChromeExtensionApiGetAdminAutofillSessionsSortByEnum, sortOrder?: AutofillChromeExtensionApiGetAdminAutofillSessionsSortOrderEnum, startDate?: string | null, status?: AutofillChromeExtensionApiGetAdminAutofillSessionsStatusEnum, userId?: string | null, version?: string | null, withNotes?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAutofillSessionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiGetAdminAutofillSessions(ats, endDate, excludeInternal, page, pageSize, search, sortBy, sortOrder, startDate, status, userId, version, withNotes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiGetAdminAutofillSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {AutofillChromeExtensionApiGetAdminAutofillTimeseriesGranularityEnum} [granularity] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiGetAdminAutofillTimeseries(endDate?: string | null, excludeInternal?: boolean, granularity?: AutofillChromeExtensionApiGetAdminAutofillTimeseriesGranularityEnum, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAutofillTimeseriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiGetAdminAutofillTimeseries(endDate, excludeInternal, granularity, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiGetAdminAutofillTimeseries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AutofillChromeExtensionApiGetAdminAutofillUsersActivityEnum} [activity] 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {AutofillChromeExtensionApiGetAdminAutofillUsersSortByEnum} [sortBy] 
         * @param {AutofillChromeExtensionApiGetAdminAutofillUsersSortOrderEnum} [sortOrder] 
         * @param {string | null} [startDate] 
         * @param {string | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiGetAdminAutofillUsers(activity?: AutofillChromeExtensionApiGetAdminAutofillUsersActivityEnum, endDate?: string | null, excludeInternal?: boolean, page?: number, pageSize?: number, search?: string | null, sortBy?: AutofillChromeExtensionApiGetAdminAutofillUsersSortByEnum, sortOrder?: AutofillChromeExtensionApiGetAdminAutofillUsersSortOrderEnum, startDate?: string | null, userId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAutofillUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiGetAdminAutofillUsers(activity, endDate, excludeInternal, page, pageSize, search, sortBy, sortOrder, startDate, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiGetAdminAutofillUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * self-identification declarations.
         * @summary What we remember for this candidate — inspectable because it includes
         * @param {string | null} [atsSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiListAutofillSavedAnswers(atsSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAutofillSavedAnswersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiListAutofillSavedAnswers(atsSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiListAutofillSavedAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * stopped before the model, so the popup can show what a fill would spend before the candidate clicks. Takes the identical body as /autofill/answers so the extension previews exactly what it would send.
         * @summary Costs nothing and fills nothing: the same classification the fill runs,
         * @param {GenerateAutofillAnswersBody} generateAutofillAnswersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiPreviewAutofillAnswers(generateAutofillAnswersBody: GenerateAutofillAnswersBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewAutofillAnswersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiPreviewAutofillAnswers(generateAutofillAnswersBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiPreviewAutofillAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary For the web app: whether the extension a candidate had is out of date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiPublishedExtensionVersionRoute(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishedExtensionVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiPublishedExtensionVersionRoute(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiPublishedExtensionVersionRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * stage reached, a pause. Best-effort; the extension ignores the answer.
         * @summary A funnel step from the extension: panel shown, guided run started, a
         * @param {AutofillEventBody} autofillEventBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiRecordAutofillEvent(autofillEventBody: AutofillEventBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutofillEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiRecordAutofillEvent(autofillEventBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiRecordAutofillEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * click on the header\'s Web Store link. Each send updates their one row.
         * @summary The candidate\'s answer to \"how did we do?\" on the success screen, or a
         * @param {AutofillRatingBody} autofillRatingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiRecordAutofillRating(autofillRatingBody: AutofillRatingBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutofillRatingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiRecordAutofillRating(autofillRatingBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiRecordAutofillRating']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * it. Separate from the sign-in routes on purpose: it can fail without touching a login.
         * @summary Sent by the extension after each sign-in to it, so we know who uses
         * @param {ExtensionSignedInBody} extensionSignedInBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiRecordExtensionSignIn(extensionSignedInBody: ExtensionSignedInBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiRecordExtensionSignIn(extensionSignedInBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiRecordExtensionSignIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * marks the install removed, and stores why if the person says. No account (the extension is gone); capped per client address.
         * @summary From the public page Chrome opens when the extension is removed:
         * @param {AutofillUninstallBody} autofillUninstallBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiRecordExtensionUninstall(autofillUninstallBody: AutofillUninstallBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutofillUninstallResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiRecordExtensionUninstall(autofillUninstallBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiRecordExtensionUninstall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * extension\'s cover letter: found, or with `create`, added from its ATS.
         * @summary The Abekus job for the employer\'s page the candidate is on, for the
         * @param {AutofillJobBody} autofillJobBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiResolveAutofillJob(autofillJobBody: AutofillJobBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutofillJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiResolveAutofillJob(autofillJobBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiResolveAutofillJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remember answers the candidate typed, scoped to the page\'s ATS.
         * @param {SaveAutofillAnswersBody} saveAutofillAnswersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiSaveAutofillAnswers(saveAutofillAnswersBody: SaveAutofillAnswersBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveAutofillAnswersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiSaveAutofillAnswers(saveAutofillAnswersBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiSaveAutofillAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {UpdateAutofillSessionBody} updateAutofillSessionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autofillChromeExtensionApiUpdateAutofillSession(sessionId: string, updateAutofillSessionBody: UpdateAutofillSessionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateAutofillSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autofillChromeExtensionApiUpdateAutofillSession(sessionId, updateAutofillSessionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutofillChromeExtensionApiApi.autofillChromeExtensionApiUpdateAutofillSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AutofillChromeExtensionApiApi - factory interface
 */
export const AutofillChromeExtensionApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AutofillChromeExtensionApiApiFp(configuration)
    return {
        /**
         * Google client id before any user exists. Returns no user data and no secret.
         * @summary Unauthenticated on purpose — the extension\'s sign-in screen needs the
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiAutofillConfig(options?: RawAxiosRequestConfig): AxiosPromise<AutofillConfigResponse> {
            return localVarFp.autofillChromeExtensionApiAutofillConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * Jobs shows on its card — for the extension\'s panel.
         * @summary The candidate\'s match to the job on the employer\'s page — the score Find
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillJobMatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiAutofillJobMatch(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillJobMatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutofillJobMatchResponse> {
            return localVarFp.autofillChromeExtensionApiAutofillJobMatch(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiAutofillProfile(options?: RawAxiosRequestConfig): AxiosPromise<AutofillProfileResponse> {
            return localVarFp.autofillChromeExtensionApiAutofillProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * Jobs tab — the head of their Find Jobs list. No model call; SQL only.
         * @summary External jobs matched to the candidate\'s profile, for the extension\'s
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillRecommendedJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiAutofillRecommendedJobs(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillRecommendedJobsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RecommendedJobsResponse> {
            return localVarFp.autofillChromeExtensionApiAutofillRecommendedJobs(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * one they picked, or their default.
         * @summary The caller\'s own resume file, for attaching to an application form: the
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillResumeFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiAutofillResumeFile(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillResumeFileRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AutofillResumeFileResponse> {
            return localVarFp.autofillChromeExtensionApiAutofillResumeFile(requestParameters.resumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiAutofillStatus(options?: RawAxiosRequestConfig): AxiosPromise<AutofillStatusResponse> {
            return localVarFp.autofillChromeExtensionApiAutofillStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AI credits spent on autofill, and on what — the settings page\'s ledger.
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillUsageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiAutofillUsage(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillUsageRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AutofillUsageResponse> {
            return localVarFp.autofillChromeExtensionApiAutofillUsage(requestParameters.days, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * extension and the vault\'s Add AI Credits dialog. Raises `not_enough_credits` when the balance can\'t cover the order, the point at which the extension offers Go Pro and the dialog shows its shortfall panel.
         * @summary Spend credits on one or more packs of AI answers — used by both the
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiBuyAiAnswersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiBuyAiAnswers(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiBuyAiAnswersRequest, options?: RawAxiosRequestConfig): AxiosPromise<BuyAiAnswersResponse> {
            return localVarFp.autofillChromeExtensionApiBuyAiAnswers(requestParameters.buyAiAnswersBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiDeleteAutofillSavedAnswerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiDeleteAutofillSavedAnswer(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiDeleteAutofillSavedAnswerRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.autofillChromeExtensionApiDeleteAutofillSavedAnswer(requestParameters.answerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiGenerateAutofillAnswersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiGenerateAutofillAnswers(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiGenerateAutofillAnswersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateAutofillAnswersResponse> {
            return localVarFp.autofillChromeExtensionApiGenerateAutofillAnswers(requestParameters.generateAutofillAnswersBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillBreakdownRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiGetAdminAutofillBreakdown(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillBreakdownRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminAutofillBreakdownResponse> {
            return localVarFp.autofillChromeExtensionApiGetAdminAutofillBreakdown(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Chrome extension headline numbers for a window, against the window before it.
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiGetAdminAutofillOverview(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillOverviewRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminAutofillOverviewResponse> {
            return localVarFp.autofillChromeExtensionApiGetAdminAutofillOverview(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillSessionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiGetAdminAutofillSessions(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillSessionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminAutofillSessionsResponse> {
            return localVarFp.autofillChromeExtensionApiGetAdminAutofillSessions(requestParameters.ats, requestParameters.endDate, requestParameters.excludeInternal, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, requestParameters.status, requestParameters.userId, requestParameters.version, requestParameters.withNotes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillTimeseriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiGetAdminAutofillTimeseries(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillTimeseriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminAutofillTimeseriesResponse> {
            return localVarFp.autofillChromeExtensionApiGetAdminAutofillTimeseries(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.granularity, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiGetAdminAutofillUsers(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminAutofillUsersResponse> {
            return localVarFp.autofillChromeExtensionApiGetAdminAutofillUsers(requestParameters.activity, requestParameters.endDate, requestParameters.excludeInternal, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * self-identification declarations.
         * @summary What we remember for this candidate — inspectable because it includes
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiListAutofillSavedAnswersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiListAutofillSavedAnswers(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiListAutofillSavedAnswersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListAutofillSavedAnswersResponse> {
            return localVarFp.autofillChromeExtensionApiListAutofillSavedAnswers(requestParameters.atsSource, options).then((request) => request(axios, basePath));
        },
        /**
         * stopped before the model, so the popup can show what a fill would spend before the candidate clicks. Takes the identical body as /autofill/answers so the extension previews exactly what it would send.
         * @summary Costs nothing and fills nothing: the same classification the fill runs,
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiPreviewAutofillAnswersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiPreviewAutofillAnswers(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiPreviewAutofillAnswersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreviewAutofillAnswersResponse> {
            return localVarFp.autofillChromeExtensionApiPreviewAutofillAnswers(requestParameters.generateAutofillAnswersBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary For the web app: whether the extension a candidate had is out of date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiPublishedExtensionVersionRoute(options?: RawAxiosRequestConfig): AxiosPromise<PublishedExtensionVersionResponse> {
            return localVarFp.autofillChromeExtensionApiPublishedExtensionVersionRoute(options).then((request) => request(axios, basePath));
        },
        /**
         * stage reached, a pause. Best-effort; the extension ignores the answer.
         * @summary A funnel step from the extension: panel shown, guided run started, a
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordAutofillEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiRecordAutofillEvent(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordAutofillEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutofillEventResponse> {
            return localVarFp.autofillChromeExtensionApiRecordAutofillEvent(requestParameters.autofillEventBody, options).then((request) => request(axios, basePath));
        },
        /**
         * click on the header\'s Web Store link. Each send updates their one row.
         * @summary The candidate\'s answer to \"how did we do?\" on the success screen, or a
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordAutofillRatingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiRecordAutofillRating(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordAutofillRatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutofillRatingResponse> {
            return localVarFp.autofillChromeExtensionApiRecordAutofillRating(requestParameters.autofillRatingBody, options).then((request) => request(axios, basePath));
        },
        /**
         * it. Separate from the sign-in routes on purpose: it can fail without touching a login.
         * @summary Sent by the extension after each sign-in to it, so we know who uses
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordExtensionSignInRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiRecordExtensionSignIn(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordExtensionSignInRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.autofillChromeExtensionApiRecordExtensionSignIn(requestParameters.extensionSignedInBody, options).then((request) => request(axios, basePath));
        },
        /**
         * marks the install removed, and stores why if the person says. No account (the extension is gone); capped per client address.
         * @summary From the public page Chrome opens when the extension is removed:
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordExtensionUninstallRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiRecordExtensionUninstall(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordExtensionUninstallRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutofillUninstallResponse> {
            return localVarFp.autofillChromeExtensionApiRecordExtensionUninstall(requestParameters.autofillUninstallBody, options).then((request) => request(axios, basePath));
        },
        /**
         * extension\'s cover letter: found, or with `create`, added from its ATS.
         * @summary The Abekus job for the employer\'s page the candidate is on, for the
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiResolveAutofillJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiResolveAutofillJob(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiResolveAutofillJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutofillJobResponse> {
            return localVarFp.autofillChromeExtensionApiResolveAutofillJob(requestParameters.autofillJobBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remember answers the candidate typed, scoped to the page\'s ATS.
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiSaveAutofillAnswersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiSaveAutofillAnswers(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiSaveAutofillAnswersRequest, options?: RawAxiosRequestConfig): AxiosPromise<SaveAutofillAnswersResponse> {
            return localVarFp.autofillChromeExtensionApiSaveAutofillAnswers(requestParameters.saveAutofillAnswersBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiUpdateAutofillSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autofillChromeExtensionApiUpdateAutofillSession(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiUpdateAutofillSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateAutofillSessionResponse> {
            return localVarFp.autofillChromeExtensionApiUpdateAutofillSession(requestParameters.sessionId, requestParameters.updateAutofillSessionBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for autofillChromeExtensionApiAutofillJobMatch operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillJobMatchRequest {
    readonly jobId: string
}

/**
 * Request parameters for autofillChromeExtensionApiAutofillRecommendedJobs operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillRecommendedJobsRequest {
    readonly limit?: number
}

/**
 * Request parameters for autofillChromeExtensionApiAutofillResumeFile operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillResumeFileRequest {
    readonly resumeId?: string | null
}

/**
 * Request parameters for autofillChromeExtensionApiAutofillUsage operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillUsageRequest {
    readonly days?: number

    readonly limit?: number
}

/**
 * Request parameters for autofillChromeExtensionApiBuyAiAnswers operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiBuyAiAnswersRequest {
    readonly buyAiAnswersBody: BuyAiAnswersBody
}

/**
 * Request parameters for autofillChromeExtensionApiDeleteAutofillSavedAnswer operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiDeleteAutofillSavedAnswerRequest {
    readonly answerId: string
}

/**
 * Request parameters for autofillChromeExtensionApiGenerateAutofillAnswers operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiGenerateAutofillAnswersRequest {
    readonly generateAutofillAnswersBody: GenerateAutofillAnswersBody
}

/**
 * Request parameters for autofillChromeExtensionApiGetAdminAutofillBreakdown operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillBreakdownRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly startDate?: string | null
}

/**
 * Request parameters for autofillChromeExtensionApiGetAdminAutofillOverview operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillOverviewRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly startDate?: string | null
}

/**
 * Request parameters for autofillChromeExtensionApiGetAdminAutofillSessions operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillSessionsRequest {
    readonly ats?: string | null

    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly page?: number

    readonly pageSize?: number

    readonly search?: string | null

    readonly sortBy?: AutofillChromeExtensionApiGetAdminAutofillSessionsSortByEnum

    readonly sortOrder?: AutofillChromeExtensionApiGetAdminAutofillSessionsSortOrderEnum

    readonly startDate?: string | null

    readonly status?: AutofillChromeExtensionApiGetAdminAutofillSessionsStatusEnum

    readonly userId?: string | null

    readonly version?: string | null

    readonly withNotes?: boolean
}

/**
 * Request parameters for autofillChromeExtensionApiGetAdminAutofillTimeseries operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillTimeseriesRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly granularity?: AutofillChromeExtensionApiGetAdminAutofillTimeseriesGranularityEnum

    readonly startDate?: string | null
}

/**
 * Request parameters for autofillChromeExtensionApiGetAdminAutofillUsers operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillUsersRequest {
    readonly activity?: AutofillChromeExtensionApiGetAdminAutofillUsersActivityEnum

    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly page?: number

    readonly pageSize?: number

    readonly search?: string | null

    readonly sortBy?: AutofillChromeExtensionApiGetAdminAutofillUsersSortByEnum

    readonly sortOrder?: AutofillChromeExtensionApiGetAdminAutofillUsersSortOrderEnum

    readonly startDate?: string | null

    readonly userId?: string | null
}

/**
 * Request parameters for autofillChromeExtensionApiListAutofillSavedAnswers operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiListAutofillSavedAnswersRequest {
    readonly atsSource?: string | null
}

/**
 * Request parameters for autofillChromeExtensionApiPreviewAutofillAnswers operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiPreviewAutofillAnswersRequest {
    readonly generateAutofillAnswersBody: GenerateAutofillAnswersBody
}

/**
 * Request parameters for autofillChromeExtensionApiRecordAutofillEvent operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordAutofillEventRequest {
    readonly autofillEventBody: AutofillEventBody
}

/**
 * Request parameters for autofillChromeExtensionApiRecordAutofillRating operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordAutofillRatingRequest {
    readonly autofillRatingBody: AutofillRatingBody
}

/**
 * Request parameters for autofillChromeExtensionApiRecordExtensionSignIn operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordExtensionSignInRequest {
    readonly extensionSignedInBody: ExtensionSignedInBody
}

/**
 * Request parameters for autofillChromeExtensionApiRecordExtensionUninstall operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordExtensionUninstallRequest {
    readonly autofillUninstallBody: AutofillUninstallBody
}

/**
 * Request parameters for autofillChromeExtensionApiResolveAutofillJob operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiResolveAutofillJobRequest {
    readonly autofillJobBody: AutofillJobBody
}

/**
 * Request parameters for autofillChromeExtensionApiSaveAutofillAnswers operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiSaveAutofillAnswersRequest {
    readonly saveAutofillAnswersBody: SaveAutofillAnswersBody
}

/**
 * Request parameters for autofillChromeExtensionApiUpdateAutofillSession operation in AutofillChromeExtensionApiApi.
 */
export interface AutofillChromeExtensionApiApiAutofillChromeExtensionApiUpdateAutofillSessionRequest {
    readonly sessionId: string

    readonly updateAutofillSessionBody: UpdateAutofillSessionBody
}

/**
 * AutofillChromeExtensionApiApi - object-oriented interface
 */
export class AutofillChromeExtensionApiApi extends BaseAPI {
    /**
     * Google client id before any user exists. Returns no user data and no secret.
     * @summary Unauthenticated on purpose — the extension\'s sign-in screen needs the
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiAutofillConfig(options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiAutofillConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Jobs shows on its card — for the extension\'s panel.
     * @summary The candidate\'s match to the job on the employer\'s page — the score Find
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillJobMatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiAutofillJobMatch(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillJobMatchRequest, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiAutofillJobMatch(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiAutofillProfile(options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiAutofillProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Jobs tab — the head of their Find Jobs list. No model call; SQL only.
     * @summary External jobs matched to the candidate\'s profile, for the extension\'s
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillRecommendedJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiAutofillRecommendedJobs(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillRecommendedJobsRequest = {}, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiAutofillRecommendedJobs(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * one they picked, or their default.
     * @summary The caller\'s own resume file, for attaching to an application form: the
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillResumeFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiAutofillResumeFile(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillResumeFileRequest = {}, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiAutofillResumeFile(requestParameters.resumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiAutofillStatus(options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiAutofillStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary AI credits spent on autofill, and on what — the settings page\'s ledger.
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillUsageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiAutofillUsage(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiAutofillUsageRequest = {}, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiAutofillUsage(requestParameters.days, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * extension and the vault\'s Add AI Credits dialog. Raises `not_enough_credits` when the balance can\'t cover the order, the point at which the extension offers Go Pro and the dialog shows its shortfall panel.
     * @summary Spend credits on one or more packs of AI answers — used by both the
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiBuyAiAnswersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiBuyAiAnswers(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiBuyAiAnswersRequest, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiBuyAiAnswers(requestParameters.buyAiAnswersBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiDeleteAutofillSavedAnswerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiDeleteAutofillSavedAnswer(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiDeleteAutofillSavedAnswerRequest, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiDeleteAutofillSavedAnswer(requestParameters.answerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiGenerateAutofillAnswersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiGenerateAutofillAnswers(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiGenerateAutofillAnswersRequest, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiGenerateAutofillAnswers(requestParameters.generateAutofillAnswersBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillBreakdownRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiGetAdminAutofillBreakdown(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillBreakdownRequest = {}, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiGetAdminAutofillBreakdown(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Chrome extension headline numbers for a window, against the window before it.
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiGetAdminAutofillOverview(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillOverviewRequest = {}, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiGetAdminAutofillOverview(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillSessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiGetAdminAutofillSessions(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillSessionsRequest = {}, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiGetAdminAutofillSessions(requestParameters.ats, requestParameters.endDate, requestParameters.excludeInternal, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, requestParameters.status, requestParameters.userId, requestParameters.version, requestParameters.withNotes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillTimeseriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiGetAdminAutofillTimeseries(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillTimeseriesRequest = {}, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiGetAdminAutofillTimeseries(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.granularity, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiGetAdminAutofillUsers(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiGetAdminAutofillUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiGetAdminAutofillUsers(requestParameters.activity, requestParameters.endDate, requestParameters.excludeInternal, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * self-identification declarations.
     * @summary What we remember for this candidate — inspectable because it includes
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiListAutofillSavedAnswersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiListAutofillSavedAnswers(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiListAutofillSavedAnswersRequest = {}, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiListAutofillSavedAnswers(requestParameters.atsSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * stopped before the model, so the popup can show what a fill would spend before the candidate clicks. Takes the identical body as /autofill/answers so the extension previews exactly what it would send.
     * @summary Costs nothing and fills nothing: the same classification the fill runs,
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiPreviewAutofillAnswersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiPreviewAutofillAnswers(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiPreviewAutofillAnswersRequest, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiPreviewAutofillAnswers(requestParameters.generateAutofillAnswersBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary For the web app: whether the extension a candidate had is out of date.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiPublishedExtensionVersionRoute(options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiPublishedExtensionVersionRoute(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * stage reached, a pause. Best-effort; the extension ignores the answer.
     * @summary A funnel step from the extension: panel shown, guided run started, a
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordAutofillEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiRecordAutofillEvent(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordAutofillEventRequest, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiRecordAutofillEvent(requestParameters.autofillEventBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * click on the header\'s Web Store link. Each send updates their one row.
     * @summary The candidate\'s answer to \"how did we do?\" on the success screen, or a
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordAutofillRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiRecordAutofillRating(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordAutofillRatingRequest, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiRecordAutofillRating(requestParameters.autofillRatingBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * it. Separate from the sign-in routes on purpose: it can fail without touching a login.
     * @summary Sent by the extension after each sign-in to it, so we know who uses
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordExtensionSignInRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiRecordExtensionSignIn(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordExtensionSignInRequest, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiRecordExtensionSignIn(requestParameters.extensionSignedInBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * marks the install removed, and stores why if the person says. No account (the extension is gone); capped per client address.
     * @summary From the public page Chrome opens when the extension is removed:
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordExtensionUninstallRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiRecordExtensionUninstall(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiRecordExtensionUninstallRequest, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiRecordExtensionUninstall(requestParameters.autofillUninstallBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * extension\'s cover letter: found, or with `create`, added from its ATS.
     * @summary The Abekus job for the employer\'s page the candidate is on, for the
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiResolveAutofillJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiResolveAutofillJob(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiResolveAutofillJobRequest, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiResolveAutofillJob(requestParameters.autofillJobBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remember answers the candidate typed, scoped to the page\'s ATS.
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiSaveAutofillAnswersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiSaveAutofillAnswers(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiSaveAutofillAnswersRequest, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiSaveAutofillAnswers(requestParameters.saveAutofillAnswersBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AutofillChromeExtensionApiApiAutofillChromeExtensionApiUpdateAutofillSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public autofillChromeExtensionApiUpdateAutofillSession(requestParameters: AutofillChromeExtensionApiApiAutofillChromeExtensionApiUpdateAutofillSessionRequest, options?: RawAxiosRequestConfig) {
        return AutofillChromeExtensionApiApiFp(this.configuration).autofillChromeExtensionApiUpdateAutofillSession(requestParameters.sessionId, requestParameters.updateAutofillSessionBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const AutofillChromeExtensionApiGetAdminAutofillSessionsSortByEnum = {
    CreatedAt: 'created_at',
    FieldsDetected: 'fields_detected',
    FieldsFilled: 'fields_filled',
    FieldsAiGenerated: 'fields_ai_generated',
    FieldsEdited: 'fields_edited',
    AiCredits: 'ai_credits',
} as const;
export type AutofillChromeExtensionApiGetAdminAutofillSessionsSortByEnum = typeof AutofillChromeExtensionApiGetAdminAutofillSessionsSortByEnum[keyof typeof AutofillChromeExtensionApiGetAdminAutofillSessionsSortByEnum];
export const AutofillChromeExtensionApiGetAdminAutofillSessionsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc',
} as const;
export type AutofillChromeExtensionApiGetAdminAutofillSessionsSortOrderEnum = typeof AutofillChromeExtensionApiGetAdminAutofillSessionsSortOrderEnum[keyof typeof AutofillChromeExtensionApiGetAdminAutofillSessionsSortOrderEnum];
export const AutofillChromeExtensionApiGetAdminAutofillSessionsStatusEnum = {
    Detected: 'Detected',
    Filled: 'Filled',
    Submitted: 'Submitted',
    Failed: 'Failed',
} as const;
export type AutofillChromeExtensionApiGetAdminAutofillSessionsStatusEnum = typeof AutofillChromeExtensionApiGetAdminAutofillSessionsStatusEnum[keyof typeof AutofillChromeExtensionApiGetAdminAutofillSessionsStatusEnum];
export const AutofillChromeExtensionApiGetAdminAutofillTimeseriesGranularityEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
} as const;
export type AutofillChromeExtensionApiGetAdminAutofillTimeseriesGranularityEnum = typeof AutofillChromeExtensionApiGetAdminAutofillTimeseriesGranularityEnum[keyof typeof AutofillChromeExtensionApiGetAdminAutofillTimeseriesGranularityEnum];
export const AutofillChromeExtensionApiGetAdminAutofillUsersActivityEnum = {
    All: 'all',
    Active: 'active',
    Inactive: 'inactive',
    New: 'new',
    NeverFilled: 'never_filled',
} as const;
export type AutofillChromeExtensionApiGetAdminAutofillUsersActivityEnum = typeof AutofillChromeExtensionApiGetAdminAutofillUsersActivityEnum[keyof typeof AutofillChromeExtensionApiGetAdminAutofillUsersActivityEnum];
export const AutofillChromeExtensionApiGetAdminAutofillUsersSortByEnum = {
    LastSeen: 'last_seen',
    FirstSeen: 'first_seen',
    LastFill: 'last_fill',
    Name: 'name',
    Fills: 'fills',
    Applications: 'applications',
    SubmittedApplications: 'submitted_applications',
    FieldsDetected: 'fields_detected',
    FieldsFilled: 'fields_filled',
    FieldsAiGenerated: 'fields_ai_generated',
    FieldsEdited: 'fields_edited',
    AiCreditsSpent: 'ai_credits_spent',
    LifetimeFills: 'lifetime_fills',
    LifetimeApplications: 'lifetime_applications',
    LifetimeAiCredits: 'lifetime_ai_credits',
} as const;
export type AutofillChromeExtensionApiGetAdminAutofillUsersSortByEnum = typeof AutofillChromeExtensionApiGetAdminAutofillUsersSortByEnum[keyof typeof AutofillChromeExtensionApiGetAdminAutofillUsersSortByEnum];
export const AutofillChromeExtensionApiGetAdminAutofillUsersSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc',
} as const;
export type AutofillChromeExtensionApiGetAdminAutofillUsersSortOrderEnum = typeof AutofillChromeExtensionApiGetAdminAutofillUsersSortOrderEnum[keyof typeof AutofillChromeExtensionApiGetAdminAutofillUsersSortOrderEnum];
